import Column from '@components/Column'
import React from 'react'

function PeopleListPlaceholder(): JSX.Element {
    return (
        <Column>
            {/* <div className={styles.gradient} />
            <SpaceCardPlaceholder />
            <SpaceCardPlaceholder />
            <SpaceCardPlaceholder />
            <SpaceCardPlaceholder />
            <SpaceCardPlaceholder /> */}
        </Column>
    )
}

export default PeopleListPlaceholder
